import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ImageComponent from '../../../components/common/Image';
import { logout } from '../../../slices/auth/authSlice'
import Loader from "../../common/Loader";
import DatePicker from '../../common/DatePicker';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../common/Modal';
import { fetchData, fetchNotification, setApplicationDetail, setDealerCode } from '../../../slices/dashboard/dashboardSlice'
import { dealerCheck, setStage, setSubStage } from '../../../slices/eligibility/eligibilitySlice';

const DashboardContent = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.auth);
  console.log(userData?.response_data?.dealer_data)
  const userName = userData?.response_data?.data?.userName || '';
  const dealerName = userData?.response_data?.dealer_data?.[0]?.dealername || ""
  const emailID = userData?.response_data?.data?.emailID || '';
  const [addentum, setAddendum] = useState(false);

  const { dashboardDetails } = useSelector((state) => state.dashboard);
  const dealerData = userData?.response_data?.dealer_data || [];

  const userType = userData?.response_data?.data?.userType;
  const isDealer = userType === 'dealer';

  const [loader, setLoader] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [selectedPeriod, setSelectedPeriod] = useState('Day');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedDealer, setSelectedDealer] = useState({ code: 'all', name: 'All Stores' });
  const [tempSelectedDealer, setTempSelectedDealer] = useState({ code: 'all', name: 'All Stores' });
  const [searchTerm, setSearchTerm] = useState('');
  const [showDealerModal, setShowDealerModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const filteredDealers = dealerData.filter((dealer) =>
    dealer.dealercode.toLowerCase().includes(searchTerm.toLowerCase()) ||
    dealer.dealername.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Add status options
  const statusOptions = [
    { value: 'all', label: 'All' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'approved', label: 'Approved' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'disbursed', label: 'Disbursed' },
    { value: 'rejected', label: 'Rejected' }
  ];

  let href = "#"

  const handleKeyPress = (event, callback) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      callback();
    }
  };

  // Function to format date from YYYY-MM-DD to DD-MM-YYYY
  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    const dateObj = new Date(year, parseInt(month, 10) - 1, parseInt(day, 10));
    // Pad day with leading zero
    const dayStr = String(dateObj.getDate()).padStart(2, '0');
    const monthAbbr = dateObj.toLocaleString('en-US', { month: 'short' }).slice(0, 3);
    return `${dayStr} ${monthAbbr} ${dateObj.getFullYear()}`;
  };

  // Function to get date range based on selected period
  const getDateRange = (period) => {
    const now = new Date();
    let fromDate, toDate;

    switch (period) {
      case 'Day':
        // Set to 1 day (yesterday to today)
        fromDate = new Date(); // Yesterday
        toDate = new Date(); // Today
        break;
      case 'Week':
        // Set to 1 week from current date (7 days ago to today)
        fromDate = new Date(now.getTime() - (7 * 24 * 60 * 60 * 1000));
        toDate = new Date();
        break;
      case 'Month':
        // Set to 2 months from current date
        fromDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        toDate = new Date();
        break;
      case 'Years':
        fromDate = new Date(now.getFullYear(), 0, 1);
        toDate = new Date();
        break;
      default:
        fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        toDate = new Date();
    }

    return {
      from_dt: fromDate.toISOString().slice(0, 10) + ' 00:00:00',
      to_dt: toDate.toISOString().slice(0, 10) + ' 23:59:59'
    };
  };

  // Function to fetch dashboard data - Updated to accept dealer code parameter
  const fetchDashboardData = (params = {}, dealerCode = null) => {
    setLoader(true);

    // Use the passed dealer code or fall back to selectedDealer.code
    const currentDealerCode = dealerCode !== null ? dealerCode : selectedDealer.code;

    // Format payload according to the required structure
    const apiParams = {
      from_dt: params.from_dt || dateFrom + ' 00:00:00',
      to_dt: params.to_dt || dateTo + ' 23:59:59',
      status: selectedStatus || 'all',
      dealer_code: currentDealerCode || 'all'
    };

    dispatch(fetchData(apiParams))
      .unwrap()
      .then((res) => {
      })
      .catch((error) => {
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchAllNotification = () => {
    setLoader(true)
    dispatch(fetchNotification({ source_by: userData?.response_data?.data?.userID }))
      .unwrap()
      .then((res) => {
        if (res?.response_code === "S100") {
        } else {
          toast.error(res?.response_string);
        }
      })
      .catch((error) => {
      })
      .finally(() => {
        setLoader(false);
      });
  }

  // Update the useEffect to pass dealer code for dealer users
  useEffect(() => {
    // Initialize with current day data
    const initialDateRange = getDateRange('Day');
    setDateFrom(initialDateRange.from_dt.split(' ')[0]);
    setDateTo(initialDateRange.to_dt.split(' ')[0]);

    // If user is a dealer, set the dealer code automatically and fetch data with it
    if (isDealer && dealerData.length > 0) {
      const dealerInfo = {
        code: dealerData[0].dealercode,
        name: dealerData[0].dealername
      };
      setSelectedDealer(dealerInfo);
      setTempSelectedDealer(dealerInfo);

      // Fetch dashboard data with dealer code
      fetchDashboardData(initialDateRange, dealerData[0].dealercode);
    } else {
      // For non-dealer users, fetch without specific dealer code
      fetchDashboardData(initialDateRange);
    }

    fetchAllNotification();
  }, [dispatch, isDealer]);

  // Handle period selection
  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    const dateRange = getDateRange(period);
    setDateFrom(dateRange.from_dt.split(' ')[0]);
    setDateTo(dateRange.to_dt.split(' ')[0]);
    fetchDashboardData(dateRange);
  };

  // Handle custom date range
  const handleCustomDateRange = () => {
    if (dateFrom && dateTo) {
      const fromDate = new Date(dateFrom);
      const toDate = new Date(dateTo);
      const now = new Date();
      // Check if fromDate is after toDate
      if (fromDate > toDate) {
        toast.warning('Invalid Date Selection');
        const todayStr = now.toISOString().slice(0, 10);
        setDateFrom(todayStr);
        setDateTo(todayStr);
        return;
      }
      // Calculate the difference in months (max 2 months allowed)
      const yearDiff = toDate.getFullYear() - fromDate.getFullYear();
      const monthDiff = toDate.getMonth() - fromDate.getMonth() + yearDiff * 12;
      // If same month, allow; if 1 or 2 months, check day
      if (monthDiff > 2 || (monthDiff === 2 && toDate.getDate() > fromDate.getDate())) {
        toast.warning('Date range should not exceed 2 months');
        return;
      }
      const params = {
        from_dt: dateFrom + ' 00:00:00',
        to_dt: dateTo + ' 23:59:59'
      };
      fetchDashboardData(params);
      setShowDateModal(false);
    }
  };

  // Handle dealer selection (temporary selection)
  const handleDealerSelect = (dealer) => {
    const dealerInfo = {
      code: dealer.dealercode,
      name: dealer.dealername
    };
    setTempSelectedDealer(dealerInfo);
  };

  // Handle "All Dealers" selection (temporary selection)
  const handleAllDealersSelect = () => {
    setTempSelectedDealer({ code: 'all', name: 'All Stores' });
  };

  // Handle proceed button click - Fixed to pass the correct dealer code
  const handleDealerProceed = () => {

    setSelectedDealer(tempSelectedDealer);

    // Fetch data with selected dealer - pass the dealer code directly
    const params = {
      from_dt: dateFrom + ' 00:00:00',
      to_dt: dateTo + ' 23:59:59'
    };

    // Pass the tempSelectedDealer.code directly to avoid state update delay
    fetchDashboardData(params, tempSelectedDealer.code);

    // Close modal
    setShowDealerModal(false);
  };

  // Extract counts from API response
  const responseData = dashboardDetails?.response_data || [];
  const statusCounts = responseData?.reduce((acc, item) => {
    acc[item.status] = item.count;
    return acc;
  }, {});

  const costCounts = responseData?.reduce((acc, item) => {
    acc[item.status] = item.total_cost;
    return acc;
  }, {});

  const approvedCount = statusCounts['approved'] || 0;
  const inProgressCount = statusCounts['in-progress'] || 0;
  const cancelledCount = statusCounts['cancelled'] || 0;
  const disbursedCount = statusCounts['hold'] || 0;
  const rejectedCount = statusCounts['rejected'] || 0;

  const approvedCost = costCounts['approved'] || 0;
  const inProgressCost = costCounts['in-progress'] || 0;
  const cancelledCost = costCounts['cancelled'] || 0;
  const disbursedCost = costCounts['hold'] || 0;
  const rejectedCost = costCounts['rejected'] || 0;

  const disbursementApprovedCount = statusCounts['disbursed'] || 0;
  const disbursementQueueCount = statusCounts['queue'] || 0;
  const totalDisbursementCount = disbursementApprovedCount + disbursementQueueCount;

  const disbursementApprovedPercentage = totalDisbursementCount > 0 ? (disbursementApprovedCount / totalDisbursementCount) * 100 : 0;
  const disbursementQueuePercentage = totalDisbursementCount > 0 ? (disbursementQueueCount / totalDisbursementCount) * 100 : 0;

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
    setShowProfileModal(false);
  };

  const handleNavigateToDealer = () => {
    navigate('/eligiblity');
  };

  // Function to handle status card click
  const handleStatusCardClick = (status) => {
    const params = {
      from_dt: dateFrom + ' 00:00:00',
      to_dt: dateTo + ' 23:59:59',
      status: status,
      dealer_code: selectedDealer.code
    };

    navigate('/application', { state: params });
  };

  const checkStatus = async () => {
    if (userData?.response_data?.data?.userType === "dealer" || userData?.response_data?.data?.userType === "dealer_employee") {
      setLoader(true)
      const res = await dispatch(dealerCheck({
        dealer_code: userData?.response_data?.dealer_data?.[0]?.dealercode
      })).unwrap()
      setLoader(false)
      if (res?.response_code === 'S100') {
        if (res?.response_data?.is_addendum_present === false) {
          setAddendum(res?.response_data?.addendum_link)
        }
        else {
          navigate('/eligiblity'); dispatch(setDealerCode()); dispatch(setStage('')); dispatch(setSubStage('')); dispatch(setApplicationDetail())
        }
      }
      else {
        toast.error(res?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    }
    else {
      navigate('/eligiblity'); dispatch(setDealerCode()); dispatch(setStage('')); dispatch(setSubStage('')); dispatch(setApplicationDetail())
    }
  }

  return (
    <>
      <div className="kyc-tab-dashcount dashboard-bg">
        <div className="container-fluid dbNav">
          {loader === true && <Loader />}

          <div className="row">
            <div className="col-12 mb-4 mt-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="dataView fs-6">Dashboard</div>
                {isDealer ? (
                  <div className="text-grey d-flex align-items-center gap-1">
                    {selectedDealer.name}
                  </div>
                ) : (
                  <div
                    className="text-grey d-flex align-items-center gap-1"
                    onClick={() => setShowDealerModal(true)}
                    onKeyDown={(e) => handleKeyPress(e, () => setShowDealerModal(true))}
                    tabIndex={0}
                    role="button"
                    aria-label="Select dealer"
                  >
                    {selectedDealer.name}<i className="icon-arrowdown-L1"></i>
                  </div>
                )}
              </div>
            </div>

            <div className="col-12">
              <div className=" ">
                <nav className="navbar MenuBtm-date">
                  <ul className="nav nav-underline nav-flex">
                    <li className="nav-item">
                      <a
                        className={`nav-link dashboard-day ${selectedPeriod === 'Day' ? 'active' : ''}`}
                        aria-current="page"
                        href={href}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); handlePeriodChange('Day');
                          }
                        }}
                        onClick={(e) => { e.preventDefault(); handlePeriodChange('Day'); }}
                      >
                        <span className="">Day</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link dashboard-week ${selectedPeriod === 'Week' ? 'active' : ''}`}
                        href={href}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); handlePeriodChange('Week');
                          }
                        }}
                        onClick={(e) => { e.preventDefault(); handlePeriodChange('Week'); }}
                      >
                        Week<span className=" "></span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link dashboard-month ${selectedPeriod === 'Month' ? 'active' : ''}`}
                        href={href}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); handlePeriodChange('Month');
                          }
                        }}
                        onClick={(e) => { e.preventDefault(); handlePeriodChange('Month'); }}
                      >
                        <span className=" ">Month</span>
                      </a>
                    </li>
                    <li className="nav-item d-none">
                      <a
                        className={`nav-link ${selectedPeriod === 'Years' ? 'active' : ''}`}
                        href={href}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); handlePeriodChange('Years');
                          }
                        }}
                        onClick={(e) => { e.preventDefault(); handlePeriodChange('Years'); }}
                      >
                        <span className=" ">Years</span>
                      </a>
                    </li>
                  </ul>
                </nav>

                <input type="date" id="datePickerInput" className="d-none" />
              </div>
            </div>
          </div>
        </div>

        <div className='container-fluid'>
          <div className='dash-tab-sroll'>
            <div className="row gy-2 gx-3 dashboard-scroll">
              <div className="col-12">
                <div id="reportrange" className="Date_range"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setShowDateModal(true)
                    }
                  }}
                  onClick={() => setShowDateModal(true)}>
                  <button className="calendar-icon-btn" id="calendarButton"
                    onClick={() => setShowDateModal(true)}>
                    <i className="icon-timecalendar01"></i>
                  </button>
                  <label className='small'>From </label>
                  <span className="fw-semibold">{formatDateForDisplay(dateFrom)} </span>
                  <span>-</span>
                  <label className='small'>To</label>
                  <span className="fw-semibold">{formatDateForDisplay(dateTo)}</span>
                </div>
              </div>

              <div className="col-12 col-lg-3 col-md-4">
                <div
                  className="db-item bg-green-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('approved');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('approved'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View approved applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-green"></div>
                    <div className="text-secondary">Approved</div>
                  </div>
                  <h1 className="bg-green-txt dealer-num">{approvedCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-purple-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('in-progress');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('in-progress'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View in-progress applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-purple"></div>
                    <div className="text-secondary">In-Progress</div>
                  </div>
                  <h1 className="bg-purple-txt dealer-num">{inProgressCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-orange-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('cancelled');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('cancelled'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View cancelled applications"
                >
                  <div className="d-flex gap-2 align-items-center  pre-sanction">
                    <div className="side-box bg-orange"></div>
                    <div className="text-secondary">Cancelled</div>
                  </div>
                  <h1 className="bg-orange-txt dealer-num">{cancelledCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-blue-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('hold');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('hold'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View hold applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-blue"></div>
                    <div className="text-secondary">Disb. Hold</div>
                  </div>
                  <h1 className="bg-blue-txt dealer-num">{disbursedCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-red-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('rejected');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('rejected'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View rejected applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-red"></div>
                    <div className="text-secondary">Declined</div>
                  </div>
                  <h1 className="bg-red-txt dealer-num">{rejectedCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-green-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('disbursed');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('disbursed'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View approved applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-green"></div>
                    <div className="text-secondary">Disb. Approved</div>
                  </div>
                  <h1 className="bg-green-txt dealer-num">{disbursementApprovedCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3 col-md-4">
                <div
                  className="db-item bg-yellow-G"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleStatusCardClick('queue');
                  }}
                  onKeyDown={(e) => handleKeyPress(e, () => handleStatusCardClick('queue'))}
                  tabIndex={0}
                  role="button"
                  aria-label="View queued applications"
                >
                  <div className="d-flex gap-2 align-items-center pre-sanction">
                    <div className="side-box bg-yellow"></div>
                    <div className="text-secondary">Disb. Queue</div>
                  </div>
                  <h1 className="bg-yellow-txt dealer-num">{disbursementQueueCount}</h1>
                  <div className="d-flex justify-content-end">
                  </div>
                </div>
              </div>

              <div className="col-sm-12 mb-4 new-login-btn">
                <div className="d-flex mt-2">
                  <button
                    className="btn btn-primary w-100 small signin dashboard-new-login"
                    type="button"
                    onClick={() => { checkStatus() }}
                  >
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <i className="icon-Essetional-add fs-6"> </i><span className="new-login-size">New Login</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className={`modal fade ${showDealerModal ? 'show' : ''}`}
        id="SelectRole"
        tabIndex="-1"
        aria-labelledby="SelectRoleLabel"
        aria-hidden={!showDealerModal}
        style={{ display: showDealerModal ? 'block' : 'none' }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowDealerModal(false);
          }
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowDealerModal(false);
          }
        }}>
        <div className="modal-dialog bottom-modal">
          <div className="modal-content blue">
            <div className="modal-header">
              <div className="top-draw"></div>
            </div>

            <div className="d-flex align-items-center justify-content-between px-4 w-100">
              <h6 className="mb-1" id="SelectRoleLabel">Stores</h6>
            </div>

            <div className="modal-body">
              <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative" role="search" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="search"
                  className="form-control input-underline"
                  placeholder="Search Stores"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="has-i-search hidden-search-box dashboard-search">
                  <span className="icon-searchnormal fs-4 inside-search"></span>
                </div>
              </form>
              <ul className="list-group list-group-flush lh-lg ul-height">
                <li
                  className={`list-group-item border-0 text-secondary fw-normal ${tempSelectedDealer.code === 'all' ? 'dealer-selected' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleAllDealersSelect()}
                  onKeyDown={(e) => handleKeyPress(e, handleAllDealersSelect)}
                  tabIndex={0}
                  role="button"
                  aria-label="Select all stores"
                >
                  All Stores
                  {tempSelectedDealer.code === 'all' && (
                    <i className="icon-check float-end text-primary"></i>
                  )}
                </li>
                {filteredDealers.length > 0 ? (
                  filteredDealers.map((dealer, index) => (
                    <li
                      key={index}
                      className={`list-group-item border-0 text-secondary fw-normal ${tempSelectedDealer.code === dealer.dealercode ? 'dealer-selected' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDealerSelect(dealer)}
                      onKeyDown={(e) => handleKeyPress(e, () => handleDealerSelect(dealer))}
                      tabIndex={0}
                      role="button"
                      aria-label={`Select dealer ${dealer.dealercode} - ${dealer.dealername}`}
                    >
                      {dealer.dealercode} - {dealer.dealername}
                      {tempSelectedDealer.code === dealer.dealercode && (
                        <i className="icon-check float-end text-primary"></i>
                      )}
                    </li>
                  ))
                ) : (
                  <li className="list-group-item border-0 text-secondary fw-semibold">
                    No dealers found
                  </li>
                )}
              </ul>
            </div>

            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleDealerProceed}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>


      {addentum &&
        <>
          <div className="modal fade show p-0" id="SelectRole" aria-labelledby="SelectRole" tabIndex="-1" style={{ display: "block", Padding: "0px" }} aria-modal="true"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setAddendum(false)
              }
            }}
            onClick={() => setAddendum(false)}>
            <div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
            >
              <div className="modal-content">
                <div className="modal-body text-center mt-3 mb-3">
                  <div className="row gy-3">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                      <ImageComponent fileName="2fverify.svg" className="img-fluid gif-tick" alt="ico-success" />
                      <br/>
                      <b className="small fs-6">{dealerName}</b>
                      <p className="small fs-6 mt-2">{`We have updated our terms of the agreement. Please complete the addendum signing to proceed with onboarding the customer.`}</p>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                      <button className="btn btn-primary w-50" type="button" onClick={() => {
                        window.open(addentum, "_blank");
                      }}>Open Link</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }

      {/* Add backdrop if needed */}
      {showDealerModal && <div className="modal-backdrop fade show"></div>}

      <div className={`modal fade ${showDateModal ? 'show' : ''}`}
        id="Dealerrole"
        tabIndex="-1"
        aria-labelledby="DealerroleLabel"
        aria-hidden={!showDateModal}
        style={{ display: showDateModal ? 'block' : 'none' }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowDateModal(false);
          }
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowDateModal(false);
          }
        }}>
        <div className="modal-dialog bottom-modal">
          <div className="modal-content blue">
            <div className="modal-header">
              <div className="top-draw"></div>
            </div>

            <div className="d-flex align-items-center justify-content-between px-4 w-100">
              <h6 className="mb-1 text-dark" id="DealerroleLabel">Date Selection</h6>
            </div>

            <div className="modal-body">
              <ul className="list-group list-group-flush">
                <div className="row gy-3">
                  <div className="col-6">
                    <DatePicker
                      value={dateFrom}
                      onChange={setDateFrom}
                      label="From"
                      required={true}
                      disableFutureDates={true}
                    />
                  </div>
                  <div className="col-6">
                    <DatePicker
                      value={dateTo}
                      onChange={setDateTo}
                      label="To"
                      required={true}
                    />
                  </div>
                  {/* <div className="col-md-12">
                    <label className="form-label" htmlFor='status'>Status</label>
                    <select
                      className="form-select"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className="col-sm-12 dashboard-date-top">
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleCustomDateRange}
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Add backdrop for date modal */}
      {showDateModal && <div className="modal-backdrop fade show"></div>}


      <Modal
        id="profilerole"
        show={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        modalClass="modal-dialog bottom-modal"
        contentClass="blue"
      >
        <ModalHeader className="">
          <div className="top-draw"></div>
        </ModalHeader>

        <div className="d-flex align-items-center justify-content-end px-4 pt-2 w-100">
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowProfileModal(false)}
            aria-label="Close"
          ></button>
        </div>

        <ModalBody>
          <div className="row gy-4 p-1">
            <div className="col-md-12">
              <div className="d-flex align-items-center gap-2">
                <ImageComponent fileName={"gender-icon.svg"} alt="profilepop" />
                <div className="name fw-semibold">
                  {userName}<br />
                  <span className="text-secondary fw-normal">{emailID}</span>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="d-flex align-items-center justify-content-between gap-4">
                <div className="d-flex gap-4 align-items-center">
                  <i className="icon-notification01 fs-4 dark-blue"></i>{' '}
                  Notifications
                </div>
                <div className="noti-count text-white">
                  2
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <a
                href={href}
                className="text-decoration-none text-black"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <div className="d-flex gap-4 align-items-center">
                  <i className="icon-arrowlogout-E1 fs-4 dark-blue"></i>{' '}
                  Logout
                </div>
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>

    </>
  );
};

export default DashboardContent;